import { useEffect, useRef } from 'react';

export function usePageFocus(onVisible?: () => void) {
  const cbRef = useRef(onVisible);
  const isVisibleRef = useRef(
    typeof document === 'undefined'
      ? true
      : document.visibilityState === 'visible'
  );

  useEffect(() => {
    cbRef.current = onVisible;
  }, [onVisible]);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined')
      return;

    const handle = () => {
      const visible = document.visibilityState === 'visible';
      isVisibleRef.current = visible;
      if (visible) cbRef.current?.();
    };

    document.addEventListener('visibilitychange', handle);
    window.addEventListener('pageshow', handle);

    handle(); // call once on mount

    return () => {
      document.removeEventListener('visibilitychange', handle);
      window.removeEventListener('pageshow', handle);
    };
  }, []);

  return isVisibleRef;
}
